import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

export default function DateField({bigPadding=false,label,value,placeholder,onChange,disabled,error,errorMessage,translateError=false,isRequird=false,fullWidth=true,today=false,beforeToday=false,time=false,inlineSmall=false}){


    const {t} = useTranslation();
    
    const startDate = new Date();
    startDate.setDate(startDate.getDate())
    
    const getMinTime = () => {
        const minTime = new Date();
        if (!value || moment(value).isSame(moment(),'day')) {
            return new Date(minTime);
        }
        return new Date(minTime.setHours(0, 0, 0, 0));
    };

    const getMaxTime = () => {
        const maxTime = new Date();
        return new Date(maxTime.setHours(23, 59, 59, 999));
    };



    return (
        <div className={`${fullWidth ? 'full-width-datepicker': ''} min-h-[40px] w-[100%] mb-[10px] relative ${inlineSmall ? '!inline-block !h-[29px] !w-[120px] !leading-[29px]' : ''}`}>
            { label && <label htmlFor={label} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{label}{isRequird && <span className="text-danger">*</span>}</label> }
            <DatePicker 
                name='date'
                showTimeSelect={time}
                dateFormat={time ? 'dd/MM/YYY hh:mm aa' : 'dd/MM/YYYY'}
                maxDate={beforeToday ? startDate : null}
                minDate={today ? startDate : null}
                minTime={getMinTime()}
                maxTime={getMaxTime()}
                popperPlacement="bottom-start"
                selected={value} 
                placeholderText={placeholder} 
                onChange={onChange} 
                className={`text-grey-600 transition-[border] !border-grey-300 ease-in-out duration-300 focus:border-lightBlue outline-none ${bigPadding ? 'px-[12px]' :'px-[3px]'} h-[48px] text-[16px] w-[100%] bg-white rounded-[8px] border justify-start items-center inline-flex leading-[48px] ${ error ? '!border-danger' : '' } ${ disabled ? '!bg-disabled !border-disabled' : '' } ${inlineSmall ? '!inline-block !h-[29px] !w-[120px] !leading-[29px] !border-grey-300 !rounded-[4px]' : ''}`}
            />
            {inlineSmall && <div className="w-[16px] h-[16px] absolute top-[6px] end-[3px]" style={{background: "url('/assets/images/drop-s-arrow.svg')"}}></div>}
            {errorMessage && <p className="text-danger text-[14px] font-[400] leading-[20px] pe-[5px] pt-[3px] mb-[0] block"><img src="/assets/images/error.svg" alt="" className="inline w-[16px] h-[16px] align-middle me-[3px]" />{translateError ? t(errorMessage) : errorMessage}</p>}
        </div>
    )
}